export default function MessageThread() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Message Thread</h1>
      <p className="text-gray-600">Message thread coming soon...</p>
    </div>
  );
}

